export const MODALS = {
  FORFEIT: 'forfeit',
  WITHDRAW_FORFEIT_BONUS_CONFIRM: 'withdraw-forfeit-bonus-confirm',
  RESET_PASSWORD_REQUIRED_MODAL: 'reset-password-required-modal',
  INVALID_FREE_SPINS: 'invalid-free-spins',
  AUTH: 'auth',
  COOKIES_MODAL: 'cookies-modal',
  ACCOUNT_FROZEN: 'account-frozen',
  USER_TEMP_BANNED_BLOCKED: 'user-temp-banned-blocked',
  BLOCKED_COUNTRY_MODAL: 'blocked-country-modal',
  FREE_SPIN_GAME_MODAL: 'free-spin-game-modal',
  MAX_BET_MODAL: 'max-bet-modal',
  RESTRICTED_GAME_MODAL: 'restricted-game-modal',
  BANNED_GAME_MODAL: 'banned-game-modal',
  GAME_PLAY_LIMIT_MODAL: 'game-play-limit-modal',
  CANCEL_SIGNUP_CONFIRMATION_MODAL: 'cancel-signup-confirmation-modal',
  CANCEL_MODAL: 'cancel-modal',
  BONUS_STATUS_MODAL: 'bonus-status-modal',
  FORFEIT_BONUS_MODAL: 'forfeit-bonus-modal',
  LAPSED_MODAL: 'lapsed-modal',
  BONUS_FORFEIT_WARNING_MODAL: 'bonus-forfeit-warning-modal',
  DEPOSIT_MODAL: 'deposit-modal',
  PAYMENT_RECEIPT_MODAL: 'payment-receipt-modal',
  LANGUAGE_SELECTION_MODAL: 'language-selection-modal',
  BONUS_INFORMATION_MODAL: 'bonus-information-modal',
  SPORTSBOOK_BETSLIP_MODAL: 'sportsbook-betslip-modal',
  LIMIT_CONFIRMATION_MODAL: 'limit-confirmation-modal',
  VIP_PROGRESS_MODAL: 'vip-progress-modal',
  PHONE_VERIFICATION_MODAL: 'phone-verification-modal',
  RESTRICT_DEPOSIT_MODAL: 'restrict-deposit-modal',
  GAMEPLAY_BLOCKED_MODAL: 'gameplay-blocked-modal'
}

// List of modal names that are allowed to have multiple instances open simultaneously.
// Keep it empty by default; add modal names from MODALS as needed in the future.
export const MULTI_INSTANCE_MODALS = []

export const ALLOWED_BASE_MODAL_TYPES = ['REDUX_MODAL', 'GAME_MODAL', 'I_FRAME_MODAL', 'PAYMENT_RECEIPT_MODAL']
